import { Tag } from 'antd';
import React, { FC, memo } from 'react';

interface SystemTagProps {
  data: any;
  closabel?: boolean;
  style?: React.CSSProperties;
  onClose?: () => void;
}

const SystemTag: FC<SystemTagProps> = ({ data, closabel, style, onClose }) => {
  if (!data) return null;

  return (
    <Tag
      closable={closabel}
      onClose={onClose}
      style={{ ...(style || {}), color: '#000', background: data.color || '#fff', border: '1px solid #f0f0f0' }}
    >
      {data.name}
    </Tag>
  );
};
export default memo(SystemTag);
